import { useLocalSearchParams } from 'expo-router';
import { SeasonPicksScreen } from '../../../../components/competitions/SeasonPicks/SeasonPicksScreen';
import { TournamentPicksScreen } from '../../../../components/competitions/TournamentPicks/TournamentPicksScreen';
import { useCompetitionsListQuery } from '../../../../src/competitions/hooks/useCompetitionsListQuery';

/**
 * Picks screen for a competition, chosen by its format (specs/champions-league AC-2.1).
 * SEASON groups by matchweek; TOURNAMENT groups by stage.
 *
 * Falls back to the season screen while the competitions list is still loading, and for an
 * unknown format: it is the safe default, since a season pool is the shape every existing
 * non-WC competition has.
 */
export default function CompetitionScreen() {
  const { competitionId } = useLocalSearchParams<{ competitionId: string }>();
  const { data: competitions } = useCompetitionsListQuery();

  const format = competitions?.find((c) => c.id === competitionId)?.format;

  return format === 'TOURNAMENT' ? <TournamentPicksScreen /> : <SeasonPicksScreen />;
}
